import { useState } from "react"
import { FormError, FormLabel, InputLista, Modal } from "../../common"
import { useFormErrors, useManagedContext } from "../../hooks"
import { standardRequest } from "../../../utils/requests"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../../config/apis"
import { ServerRequest } from "../../../utils/apiweb"
import {TIPS} from "../../../consts/tips";
import { useConfiguracion } from '../../hooks/useConfiguracion';
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage";

const ExportadorModal = ({ close }) => {
    const { setIsLoading } = useManagedContext()

    const [reportesARBADisponible] = useConfiguracion({ key: 'ReportesARBADisponible' });
    const [tipoArchivo, setTipoArchivo] = useState()

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message)
                setIsLoading(false)
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message)
                setIsLoading(false)

            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message)
        setIsLoading(false)
    }
    const callbackSuccess = (response) => {
        response.json()
        .then(() => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, 'El proceso se inició correctamente')
            setIsLoading(false)
            close()
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message)
            setIsLoading(false)
        })
    };

    const { errorOf, validate } = useFormErrors(getErrors)

    function getErrors() {
        const errors = {}

        if (!tipoArchivo) errors.idTipoArchivoExportacion = VALIDATION_MESSAGE.REQUIRED_OPTION

        return errors
    }

    const onAccept = async () => {

        if (!validate()) return

        setIsLoading(true)

        const paramsUrl = `/async/${tipoArchivo.codigo}`

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.EXPORTADOR,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    return (
        <Modal
            onEscape={() => close()}
            show
            title="Exportaciones"
            tipName={TIPS.NAME.MODALS.EXPORTADOR_MODAL}
            body={(
                <div className='row form-basic'>

                    <div className="col-12 col-md-4 col-lg-4">
                        <FormLabel htmlFor="idTipoArchivoExportacion" required>Tipo de archivo</FormLabel>
                        <InputLista
                            name="idTipoArchivoExportacion"
                            placeholder=""
                            className={`form-control ${errorOf('idTipoArchivoExportacion') ? 'is-invalid' : ''}`}
                            value={tipoArchivo?.id ?? 0}
                            onChange={({ target: { row } }) => setTipoArchivo(row)}
                            disabled={false}
                            lista="TipoArchivoExportacion"
                            filter={(row) => reportesARBADisponible !== "NO" || row.codigo.substring(0, 4) !== "ARBA"}

                        />
                        <FormError message={errorOf('idTipoArchivoExportacion')} />
                    </div>

                </div>
            )}
            footer={<>
                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={() => close()}>Cancelar</button>
                <button className="btn btn-primary" data-dismiss="modal" onClick={onAccept}>Aceptar</button>
            </>}
        />
    )
}

export default ExportadorModal
